import { EasyField } from '../baseClasses/easyField';
import { FieldOptions } from '../index';

export class EasyCheckboxField extends EasyField {
  controlType = 'checkbox';
  type: string;  

  constructor(options: FieldOptions<any> = {}) {
    super(options);
    options.controlType = this.controlType;
    this.type = options['type'] || '';
    this.marginLeft = options.marginLeft;
    this.marginTop = options.marginTop;
    this.marginRight = options.marginRight;
    this.marginBottom = options.marginBottom;
  }
}
